import {Injectable} from '@angular/core';
import {SettingsService} from './settings.service';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {Travel, User} from '../models';
// import {UserExtended} from 'app/models';
import {Observable} from 'rxjs';
// import {PrepareParams} from 'app/common/prepare-params';
import {StorageService} from './storage.service';
import {Client} from "app/models";


@Injectable()
export class UsersService {
    apiUrl: string;

    constructor(private http: HttpClient,
                private settings: SettingsService,
                private storage: StorageService) {
        this.apiUrl = this.settings.apiUrl;
    }


    getProfile(): Observable<any> {

        const clientId = this.storage.userId;

        return this.http.get(`${this.apiUrl}/client/${clientId}`).pipe(map((resp: any) => {
            // const user = new User().setFromApiModel(resp);
            // console.log('!!!!!resp', resp)
            // user.image = user.image ? `${this.apiUrl}/file/${user.image}?token=${this.storage.accessToken}` : null;
            // return user;
            return new Client().setFromApiModel(resp);
        }));
    }


    // getClient(id): Observable<Client> {
    //   return this.http.get(`${this.apiUrl}/client/${id}`).pipe(map((resp: any) => {
    //     return new Client().setFromApiModel(resp);
    //   }));
    // }


    getProfileTravels(): Observable<any> {
        const clientId = this.storage.userId;
        return this.http.get(`${this.apiUrl}/travels/client/${clientId}/expenses`).pipe(map((resp: any) => {
            return resp.list.map(item => {
                item.image = item.image ? `${this.apiUrl}/file/travel-image/${item.image}?token=${this.storage.accessToken}` : null;
                return new Travel().setFromApiModel(item);
            })
        }));
    }


    changePassword(data: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/client/change-password`, data).pipe(map((resp: any) => {
            return resp;
        }));
    }

    editUser(data: any, id: number, isUser?: boolean): Observable<any> {
        const url = id ? `${this.apiUrl}/user/${id}` : `${this.apiUrl}/user`;
        return this.http.put(url, data).pipe(map((item: any) => {
            if (item.image) {
                item.image = `${this.apiUrl}/file/${item.image}?token=${this.storage.accessToken}`;
            }
            if (isUser) {
                this.storage.user = {
                    name: `${item.first_name} ${item.last_name}`,
                    email: item.email,
                    role: data.role
                };
            }
            return new User().setFromApiModel(item);
        }));
    }

    sortElement(list, param: string, key: string) {

        return list.sort((a, b) => {
            if (key === 'desc') {
                return b[param] - a[param];
            } else {
                return a[param] - b[param];
            }
        })
    }

}
